import { ChangeDetectionStrategy, Component } from "@angular/core";

@Component({
  selector: "app-detail-header-template",
  templateUrl: "./detail-header-template.component.html",
  styleUrls: ["./detail-header-template.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailHeaderTemplateComponent {
}
